

angular.module('sample.widgets.recentlyAddedProjects',
  [
    'adf.provider',
    "ngResource",
    "LocalStorageModule",
    "EICDataStream3.resources",
    "ui.router",
    'ui.bootstrap.tooltip',
    "EICDataStream3.userData"
  ])
  .config(['dashboardProvider', function (dashboardProvider) {
    dashboardProvider
      .widget('recentlyAddedProjects',
        {
          id: 'recentlyAddedProjects',
          title: 'Recently Added Projects',
          description: 'Displays a list of recently added projects',
          controller: 'RecentlyAddedProjectsDashboardController',
          //   controllerAs: 'list',
          templateUrl:
            '/app-ds3/dashboard/widgets/recentlyAddedProjects/recentlyAddedProjects.partial.html' //,
          //            edit:         {
          //              templateUrl: '/app/angular-dashboard-framework/widgets/linklist/edit.html',
          //              reload:      false,
          //              controller:  'linklistEditCtrl'
          //            }
        });
  }])
  .controller('RecentlyAddedProjectsDashboardController',
    [
      '$scope', '$q', 'recentlyAddedProjects', '$state', 'localStorageService', "userAccessService", "lookupTables",
      function ($scope, $q, recentlyAddedProjects, $state, localStorageService, userAccessService, lookupTables) {
        $scope.componentName = "RecentlyAddedProjectsDashboardController";
  var accessRequestCanceler = $q.defer();
  var recentlyAddedProjectsRequest = null;


        $scope.recentlyAddedProjects = [];

        var sectorVisibility = function (sectorId) {
          if (!$scope.access) return false;
          return ($scope.access.accessType !== 'industry' ||
            $scope.access.allowedSectors.indexOf(sectorId) !== -1);
        };


        // fetch the list from the lookup tables endpoint
        // and transform it.
        lookupTables.industrySectors().$promise
          .then(function (sectors) {
            var allSectorIds = sectors.map(function (s) { return s.id });

            // get the list of previously  selected sectors from a Local Storage.
            // if the selected list doesn't exist, set it to the whole list 
            var selectedSectors = localStorageService.get("dashboard.recentlyAddedProjectEnergySectors")
              || allSectorIds;

            var listItems = sectors.map(function (s) {
              return {
                text: s.name,
                value: s.id,
                selected: selectedSectors.indexOf(s.id) !== -1,
                visible: sectorVisibility
              };
            });

            var nameArray = [];
            sectors.forEach(function (s) {
              nameArray[s.value] = s.name;
            });


            $scope.energySectors = {
              listItems: listItems,
              selected: selectedSectors || [],
              names: nameArray
            };
          })
          .catch(function () {
            console.log("Promise Rejected When reading Industry Sectors");
          });


        userAccessService.getRights({ timeout: accessRequestCanceler.promise })
          .then(function (response) {
            $scope.access = response.data;
          })
          .catch(function () {
            console.log("userAccessService.getRights: Promise Rejected");
          });


        $scope.getRecentlyAddedProjects = function () {
          recentlyAddedProjectsRequest = recentlyAddedProjects.query({ days: 14 });
          $scope.recentlyAddedProjects = recentlyAddedProjectsRequest;
        };

        $scope.selectProject = function (project) {
          var newState = "search.project";
          $state.go(newState, { projectID: project.projectID, projectName: project.projectName.urlEncode() });
        };


        $scope.$on('$viewContentLoaded',
          function () {
            $scope.getRecentlyAddedProjects();
          });


        $scope.$emit('$viewContentLoaded', [1, 2, 3]);

        $scope.$on('$destroy',
          function () {
            accessRequestCanceler.resolve();
            if (recentlyAddedProjectsRequest && angular.isFunction(recentlyAddedProjectsRequest.$cancelRequest)) {
              recentlyAddedProjectsRequest.$cancelRequest();
            }
            localStorageService.set("dashboard.recentlyAddedProjectEnergySectors",
              $scope.energySectors.selected,
              { expires: 28, expirationUnit: 'days' });
          });
      }
    ]);

